import "./works.scss"
import ParticlesBg from "particles-bg"
import {BsArrowRight} from "react-icons/bs"
import {IoIosArrowForward , IoIosArrowBack} from "react-icons/io"
import {data} from "../../data"
import { useState } from "react"

export default function Works() {

    const [currSlide, setcurrSlide] = useState(0);

    const handleClick = (dir) => {
        dir === "left" ? setcurrSlide(currSlide > 0 ? currSlide-1 : data.length - 1) : setcurrSlide(currSlide <  data.length - 1 ? currSlide+1 : 0)
    }

    return (
        <div className="works" id="works">
            <div className="slider" style={{transform:`translateX(-${currSlide * 100}vw)`}}>
                {data.map((d) => (
                    <div className="container">
                    <div className="item">
                        <div className="left">
                            <div className="leftContainer">
                                <h2>{d.title}</h2>
                                <p>{d.desc}</p>
                                <a href={d.link} className="gitlinkarrow">
                                    <BsArrowRight color="whitesmoke" fontSize="2.3rem"/>
                                </a>
                                <a href={d.link} className="gitLink">Github Link</a>
                            </div>
                        </div>
                        <div className="right">
                            <img src={d.img}/>
                        </div>
                    </div>
                    </div> 
                ))}
                
            </div>
            <ParticlesBg num={30} color="" type="cobweb" bg={{
                position: "absolute",
                zIndex: -1
            }}/>
            <span className="arrow left" onClick={()=>handleClick("left")}><IoIosArrowBack color="crimson" fontSize="50px"/></span>
            <span className="arrow right" onClick={()=>handleClick("right")}><IoIosArrowForward color="crimson" fontSize="50px"/></span>
        </div>
    )
}
